// extracted by mini-css-extract-plugin
export var bell = "header-module--bell--8664b";
export var globalHeader = "header-module--globalHeader--74893";
export var header = "header-module--header--9422c";
export var headerIcon = "header-module--headerIcon--e11ec";
export var headerIconLink = "header-module--headerIconLink--f5e26";
export var headerLanguageSelector = "header-module--headerLanguageSelector--a7702";
export var myAlert = "header-module--myAlert--84a6c";
export var subsidiaryLogo = "header-module--subsidiaryLogo--49770";
export var webViewHeader = "header-module--webViewHeader--63b04";